/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */

export type EmploymentType = typeof EmploymentType[keyof typeof EmploymentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmploymentType = {
  CONTRACTUAL: 'CONTRACTUAL',
  PERMANENT: 'PERMANENT',
} as const;
